import { DiscountProvider } from "@redotech/cockroachdb-codegen/congodb/discount-provider";
import { Provider } from "@redotech/redo-order-common/provider";
import { filterTruthy, unique } from "@redotech/util/array";
import { reverseRecord } from "@redotech/util/records-utils";

export const discountProviderToProvider: Record<DiscountProvider, Provider> = {
  [DiscountProvider.Bigcommercediscount]: Provider.BIGCOMMERCE,
  [DiscountProvider.Shopifydiscount]: Provider.SHOPIFY,
};

const providerToDiscountProvider: Partial<Record<Provider, DiscountProvider>> =
  reverseRecord(discountProviderToProvider);

/**
 * Resolve a team's discount provider (Shopify/BigCommerce only). Returns
 * undefined for any other store; callers MUST handle it rather than throw.
 */
export function resolveDiscountProvider(
  availableProviders: readonly Provider[],
): DiscountProvider | undefined {
  const availableDiscountProviders = unique(
    filterTruthy(
      availableProviders.map(
        (provider) => providerToDiscountProvider[provider],
      ),
    ),
  );

  if (
    availableDiscountProviders.includes(DiscountProvider.Bigcommercediscount)
  ) {
    return DiscountProvider.Bigcommercediscount;
  } else if (
    availableDiscountProviders.includes(DiscountProvider.Shopifydiscount)
  ) {
    return DiscountProvider.Shopifydiscount;
  } else {
    return undefined;
  }
}
